import React, { useRef, useState, useEffect } from "react";
import "./css/Feature2.css";

export default function Feature() {
  const cardRef = useRef(null);
  const [hovering, setHovering] = useState(false);
  const rafRef = useRef(null);

  // Your final IPFS image
  const CARD_IMAGE =
    "https://pcgslabs.infura-ipfs.io/ipfs/QmaGsYcR8NQX6j4mufWSnv4J2PDrFy2KWxe2QkC6PJSCGp";

  // --- Tilt and glare motion tracking ---
  const handlePointerMove = (e) => {
    const el = cardRef.current;
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const x = e.clientX ?? (e.touches && e.touches[0]?.clientX);
    const y = e.clientY ?? (e.touches && e.touches[0]?.clientY);
    if (typeof x !== "number" || typeof y !== "number") return;

    const px = (x - rect.left) / rect.width;
    const py = (y - rect.top) / rect.height;

    const maxTilt = 12;
    const ry = (px - 0.5) * (maxTilt * 2);
    const rx = (0.5 - py) * (maxTilt * 2);

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      el.style.setProperty("--rx", `${rx.toFixed(2)}deg`);
      el.style.setProperty("--ry", `${ry.toFixed(2)}deg`);
      el.style.setProperty("--px", `${(px * 100).toFixed(2)}%`);
      el.style.setProperty("--py", `${(py * 100).toFixed(2)}%`);
    });
  };

  const resetTilt = () => {
    const el = cardRef.current;
    if (!el) return;
    el.style.setProperty("--rx", "0deg");
    el.style.setProperty("--ry", "0deg");
    el.style.setProperty("--px", "50%");
    el.style.setProperty("--py", "50%");
  };

  useEffect(() => {
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  // --- Add clicked state to links ---
  const handleLinkClick = (e) => {
    e.currentTarget.classList.add("clicked");
  };

  return (
    <section className="feature2">
      <h2>Feature 2</h2>
      <p className="subtitle">
        Hover or touch the card to see the 3D tilt effect.
      </p>

      <div className="card-stage">
        <button
          type="button"
          className={`tilt-card ${hovering ? "is-hover" : ""}`}
          ref={cardRef}
          onMouseEnter={() => setHovering(true)}
          onMouseLeave={() => {
            setHovering(false);
            resetTilt();
          }}
          onMouseMove={handlePointerMove}
          onTouchStart={(e) => {
            setHovering(true);
            handlePointerMove(e);
          }}
          onTouchMove={handlePointerMove}
          onTouchEnd={() => {
            setHovering(false);
            resetTilt();
          }}
          onBlur={() => {
            setHovering(false);
            resetTilt();
          }}
          aria-label="Holographic trading card"
        >
          {/* --- Card artwork (no overlays) --- */}
          <img className="card-img" src={CARD_IMAGE} alt="Card artwork" />

          {/* Frame outline */}
          <span className="frame" aria-hidden="true" />

          {/* Title label with holographic overlays */}
          <span className="label title-label" aria-hidden="true">
            PCGSLABS // ID: ####
            <span className="foil" aria-hidden="true" />
            <span className="glare" aria-hidden="true" />
          </span>

          {/* Clickable link labels at bottom-left with holographic overlays */}
          <div className="labels-group">
            {["NFT", "History", "Exchange", "Pop Report"].map((text) => (
              <a
                key={text}
                className="label"
                href="https://www.google.com"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                {text}
                <span className="foil" aria-hidden="true" />
                <span className="glare" aria-hidden="true" />
              </a>
            ))}
          </div>
        </button>
      </div>
    </section>
  );
}
